module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (217).08654e83.jpg";